import React, { useState, useEffect } from 'react';
import { Menu, X, Phone } from 'lucide-react';
import { Button } from './ui/button';
import { doctorInfo } from '../data/mock';

const Header = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
      setIsMobileMenuOpen(false);
    }
  };

  const handleCall = () => {
    window.location.href = `tel:${doctorInfo.phone.replace(/\s/g, '')}`;
  };

  const navLinks = [
    { id: 'sobre-mi', label: 'Sobre Mí' },
    { id: 'servicios', label: 'Servicios' },
    { id: 'tarifas', label: 'Tarifas' },
    { id: 'faq', label: 'FAQs' },
    { id: 'contacto', label: 'Contacto' }
  ];

  return (
    <header className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
      isScrolled ? 'bg-white/98 backdrop-blur-md shadow-lg' : 'bg-white/95 backdrop-blur-sm'
    }`}>
      <div className="max-w-[1400px] mx-auto px-6 sm:px-8 lg:px-12">
        <div className="flex items-center justify-between h-28">
          {/* Logo */}
          <div className="flex items-center cursor-pointer group" data-testid="header-logo" onClick={() => scrollToSection('hero')}>
            <img 
              src="https://customer-assets.emergentagent.com/job_doctor-visit-6/artifacts/m46hav3g_Captura%20de%20pantalla%202026-02-25%20a%20las%2022.15.22.png" 
              alt="Dr. Carlos Sanz Martín - Médico a Domicilio" 
              className="h-16 w-auto object-contain transition-transform group-hover:scale-110"
            />
            <div className="ml-4 hidden sm:block">
              <h2 className="text-lg font-bold text-[#3D2418] group-hover:text-[#7DAAAF] transition-colors">
                Dr. Carlos Sanz Martín
              </h2>
              <p className="text-xs text-[#7DAAAF]">Médico a Domicilio</p>
            </div>
          </div>

          {/* Desktop Navigation - Very spacious */}
          <nav className="hidden xl:flex items-center gap-16" data-testid="desktop-nav">
            {navLinks.map((link) => (
              <button
                key={link.id}
                onClick={() => scrollToSection(link.id)}
                data-testid={`nav-link-${link.id}`}
                className="text-base font-medium text-gray-700 hover:text-[#7DAAAF] transition-all duration-300 relative group py-3 px-2"
              >
                <span className="relative z-10">{link.label}</span>
                <span className="absolute bottom-0 left-0 right-0 h-0.5 bg-[#7DAAAF] scale-x-0 group-hover:scale-x-100 transition-transform duration-300 origin-left"></span>
              </button>
            ))}
          </nav>

          {/* CTA Button - More prominent */}
          <div className="hidden xl:block">
            <Button 
              onClick={handleCall}
              data-testid="header-call-btn"
              className="bg-[#7DAAAF] hover:bg-[#6a959a] text-white font-bold shadow-lg hover:shadow-xl transition-all px-10 py-7 text-base rounded-xl hover:scale-105"
            >
              <Phone className="w-5 h-5 mr-3" />
              Llamar Ahora
            </Button>
          </div>

          {/* Mobile Menu Button */}
          <button
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            data-testid="mobile-menu-btn"
            className="xl:hidden text-gray-700 hover:text-[#7DAAAF] transition-colors p-2"
          >
            {isMobileMenuOpen ? <X size={28} /> : <Menu size={28} />}
          </button>
        </div>

        {/* Mobile Menu */}
        {isMobileMenuOpen && (
          <div className="xl:hidden bg-white border-t border-gray-200 py-6 animate-in shadow-lg rounded-b-2xl">
            <nav className="flex flex-col space-y-4">
              {navLinks.map((link) => (
                <button
                  key={link.id}
                  onClick={() => scrollToSection(link.id)}
                  className="text-left text-lg font-medium text-gray-700 hover:text-[#7DAAAF] transition-colors px-6 py-3 hover:bg-[#7DAAAF]/5 rounded-lg"
                >
                  {link.label}
                </button>
              ))}
              <div className="px-6 pt-4">
                <Button 
                  onClick={handleCall}
                  className="w-full bg-[#7DAAAF] hover:bg-[#6a959a] text-white font-bold py-6 text-base"
                >
                  <Phone className="w-5 h-5 mr-2" />
                  Llamar Ahora
                </Button>
              </div>
            </nav>
          </div>
        )}
      </div>
    </header>
  );
};

export default Header;
